module.exports = __webpack_public_path__ + "img/download.b08182b1.svg";